import ReportsSerializer from './base';

export default class Rubric extends ReportsSerializer {}
